import HiringAnswers from '@/modules/common/hiring/models/APP/HiringAnswers'
import type PaymentMethods from '@/modules/common/common/models/MID/PaymentMethods'
import { UserRoleEnum, ForWhomEnum } from '@/modules/core/models/enums'
import ForeignHealthInsured from '../MID/ForeignHealthInsured'

export default class ForeignHealthHiringAnswers extends HiringAnswers<ForeignHealthInsured> {
  insuranceType: number
  endDate: Date | null
  paymentType: PaymentMethods
  betterAssurance!: boolean | null
  abroadOption: number
  stayAbroadType: string

  constructor(data: any = {}) {
    super(data)

    this.insuranceType = data.insuranceType
    this.insureds = data.insureds
    this.holder = data.holder
    this.paymentType = data.paymentType
    this.endDate = data.endDate ?? null
    this.betterAssurance = data.betterAssurance ?? null
    this.abroadOption = data.abroadOption ?? 0
    this.stayAbroadType = data.stayAbroadType
  }

  get forWhom() {
    const holderRole = this.holder.role
    if (holderRole === UserRoleEnum.HOLDER_NOT_INSURED) {
      return ForWhomEnum.NOT_ME
    } else if (this._insureds.length > 1) {
      return ForWhomEnum.ME_MORE
    }

    return ForWhomEnum.ME
  }

  get forWhomPeople() {
    return this._insureds.length
  }

  get insureds(): ForeignHealthInsured[] {
    return this._insureds
  }

  set insureds(value: ForeignHealthInsured[]) {
    this._insureds = value?.map((i) => new ForeignHealthInsured(i)) ?? []
  }

  get holder(): ForeignHealthInsured {
    return this._holder
  }

  set holder(value: ForeignHealthInsured) {
    this._holder = value
  }

  get currentInsured(): ForeignHealthInsured | null {
    return this._currentInsured ?? null
  }

  set currentInsured(value: ForeignHealthInsured | null | undefined) {
    this._currentInsured = value ? new ForeignHealthInsured(value) : null
  }

  updateAttributes(newAttributes: Partial<ForeignHealthHiringAnswers>) {
    Object.assign(this, newAttributes)
  }
}
